// extracted by mini-css-extract-plugin
export default {"metricsWrapper":"IraUserTransactions_metricsWrapper__NTi-c"};